'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();

import { RumActionFunctionProvider } from '@qogita/ui/providers/real-user-monitoring'
import { ReactNode } from 'react'
import { capturePosthogAction } from 'src/core/posthog/capture-action'

export function RumProvider({ children }: { children: ReactNode }) {
  return (
    <RumActionFunctionProvider onAction={capturePosthogAction}>
      {children}
    </RumActionFunctionProvider>
  )
}
